import React, { useState, useEffect } from "react";
import { getImgPath } from "../common/helper";
import BusServicesDetails from "./BusServicesDetails";
import { t, HEADING1, HEADING2 } from "../../translations/AboutUs/BusServices";

function BusServices() {
  const [showBus, setShowBus] = useState(true);
  const [showBusService, setShowBusService] = useState(false);
  const [busService, setBusService] = useState("flybus");

  const handelOnImageClick = (param) => {
    setShowBus(false);
    setShowBusService(true);
    setBusService(param);
  };

  return (
    <React.Fragment>
      {showBus && (
        <div
          style={{
            width: "80%",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            flexDirection: "column",
            gap: "20px",
            paddingRight: "10px",
          }}
        >
          <div
            className="a-large"
            style={{ fontWeight: "600", textAlign: "left" }}
          >
            {t(HEADING1)}
          </div>
          <div
            className="a-normal"
            style={{ fontWeight: "500", textAlign: "left" }}
          >
            {t(HEADING2)}
          </div>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <div
              onClick={() => handelOnImageClick("flybus")}
              style={{ cursor: "pointer" }}
            >
              <img
                src={getImgPath("/img/aboutus/bus_service/bus1.png")}
                alt=""
              />
            </div>
            <div
              onClick={() => handelOnImageClick("airavat-club-class")}
              style={{ cursor: "pointer" }}
            >
              <img
                src={getImgPath("/img/aboutus/bus_service/bus2.png")}
                alt=""
              />
            </div>
            <div
              onClick={() => handelOnImageClick("airavat")}
              style={{ cursor: "pointer" }}
            >
              <img
                src={getImgPath("/img/aboutus/bus_service/bus.png")}
                alt=""
              />
            </div>
          </div>
        </div>
      )}

      {showBusService && <BusServicesDetails busService={busService} />}
    </React.Fragment>
  );
}

export default BusServices;
